import React from 'react';
import moment from 'moment';

const AnnotationItem = React.memo(({ annotation }) => (
  <div className='mb-2'>
    <p className='text-xs text-gray-700'>{annotation.anotacion}</p>
    <p className='text-xs text-gray-400 mt-0.5'>{moment(annotation.fecha).format('DD/MM/YYYY')}</p>
  </div>
));

export default AnnotationItem;
